/**
 * The fields a project search matches, in one place so that the projects
 * gallery and the project switcher in the top bar find the same projects.
 * The end customer's e-mail and number are what BMS users search by.
 */
export const PROJECT_SEARCH_FIELDS = [
	"meta.name",
	"meta.description",
	"endcustomerEmail",
	"endcustomerUid",
];
